import { FETCH_AUDIT, FETCH_AUDIT_DATA, FETCH_AUDIT_ERROR } from './constants';

export const fetchAudit = (params) => ({
    type: FETCH_AUDIT,
    payload: params,
});

export const fetchAuditError = () => ({
    type: FETCH_AUDIT_ERROR,
});

export const fetchAuditData = (payload) => ({
    type: FETCH_AUDIT_DATA,
    payload,
});
